import { Component, Injector, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { createCustomElement } from '@angular/elements';
import { map } from 'rxjs/operators';
import { GrowthBookService } from '../../services/growthbook.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'orderform-plain-mode-toggle',
  templateUrl: './plain-mode-toggle.component.html',
  styleUrls: ['./plain-mode-toggle.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class PlainModeToggleComponent {
  isPlainModeToggleVisible = signal(false);
  isPlainModeEnabled = toSignal(
    this._orderformFascade.globalSettings$.pipe(map((settings) => settings.is_plain_mode_enabled)),
    { initialValue: false }
  );
  isComponentVisible = computed(() => {
    return this._growthBookService.isFeatureEnabled('accessibility-toggle');
  });

  constructor(
    private readonly _orderformFascade: OrderformFascade,
    private readonly _growthBookService: GrowthBookService
  ) {}

  static defineCustomElement(injector: Injector): void {
    if (!customElements.get('ds-orderform-plain-mode-toggle')) {
      const customComponent = createCustomElement(PlainModeToggleComponent, { injector });
      customElements.define('ds-orderform-plain-mode-toggle', customComponent);
    }
  }

  togglePlainMode() {
    const currentValue = this.isPlainModeEnabled();
    this._orderformFascade.updateOrderformGlobalSettings({
      is_plain_mode_enabled: !currentValue,
    });
  }

  close(event: MouseEvent) {
    event.stopPropagation();
    this.isPlainModeToggleVisible.set(false);
  }

  changeToggleVisibility() {
    this.isPlainModeToggleVisible.update((value) => !value);
  }
}
